import { createRestSlice } from "./restSlice";

// Define the structure for an environment within a recipe
export type AgentRecipeEnvironment = {
  name: string;
  sttModel?: string;
  sttEndpointing?: number;
  variables: string[];
  functionCode: string;
  functionLanguage: string;
};

export type AgentRecipe = {
  id: string;
  userId: string;
  organizationId: string;
  name: string;
  description: string;
  defaultVoiceId: string | null;
  environments: AgentRecipeEnvironment[]; // Use the specific type here
  isPublic: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: Date | null;
};

const agentRecipeSlice = createRestSlice<AgentRecipe>("agentRecipe", "/v1/agentRecipes");

export const agentRecipeReducer = agentRecipeSlice.reducer;
export const agentRecipeActions = agentRecipeSlice.actions;
